import DashboardView from 'dashboard/DashboardView.react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import React from 'react';

import SashiDoTable from 'components/SashiDo/SashiDoTable.react';

export default class SashiDoTableView extends DashboardView {
  render_after_table() {}

  modalView() {
    return this.renderModals
      ? this.renderModals().map((modal, i) => <div key={`modal${i}`}>{modal}</div>)
      : null;
  }

  renderContent() {
    const toolbar = this.renderToolbar();
    const data = this.tableData();
    let content = null;
    if (data !== undefined) {
      if (!Array.isArray(data)) {
        // console.warn('tableData() needs to return an array of objects');
        return null;
      }
      else if (data.length === 0) {
        content = this.renderEmpty();
      }
      else {
        content = (
          <div className="box table big">
            <SashiDoTable className="hover">
              {this.renderHeaders()}
              <tbody>
                {data.map(row => this.renderRow(row))}
              </tbody>
            </SashiDoTable>
          </div>
        );
      }
    }

    const extras = this.renderExtras ? this.renderExtras() : null;

    const loadingState = this.state ? this.state.loading : false;

    return (
      <div className="page">
        {toolbar}

        <PreLoader loading={loadingState}>
          <div className="holder">
            <div className="modals">{this.modalView()}</div>
            {content}
            {extras}
          </div>
        </PreLoader>

        {this.render_after_table()}
      </div>
    );
  }
}
